import * as R from "ramda";

import { multipostingAccounts } from "../../../../Company/SocialAccounts/AccountList";

export const formatMultiposting = (getConfig, isEnabled, socialFeed = []) => {
  const jobPost = R.fromPairs(
    multipostingAccounts.map(item => [
      item.provider,
      {
        ...(getConfig(item.provider) || {}),
        enabled: isEnabled(item.provider) || false
      }
    ])
  );

  const multiposting = {
    jobPost,
    socialFeed
  };

  return multiposting;
};
